import React from "react";
import { Modal } from "react-bootstrap";
import { X } from "lucide-react";
import './ModalSuccesUpdate.css';


interface ModalSuccesUpdateProps {
  show: boolean;
  onClose: () => void;
  img?: string;
  icon?: React.ReactNode;
  title?: string;
  message?: string;
  buttonText?: string;
  buttonText2?: string;
  onPrimaryButtonClick?: () => void;
  onSecondButtonClick?: () => void;
  checkboxLabel?: string;
  onCheckboxChange?: (checked: boolean) => void;
  /** When true, the primary button renders in red (for delete confirmations) */
  isDanger?: boolean;
}

const ModalSuccesUpdate: React.FC<ModalSuccesUpdateProps> = ({
  show,
  onClose,
  img,
  icon,
  title,
  message,
  buttonText = "Done",
  buttonText2,
  onPrimaryButtonClick,
  onSecondButtonClick,
  checkboxLabel,
  onCheckboxChange,
  isDanger = false,
}) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      backdrop="static"
      dialogClassName="custom-modal"
      contentClassName="dm-content"
      backdropClassName="dm-backdrop"
    >
      {/* Close button */}
      <button
        type="button"
        className="dm-close"
        onClick={onClose}
        aria-label="Close"
      >
        <X size={18} />
      </button>

      <Modal.Body className="dm-body">
        {/* Icon / Image */}
        {icon && <div className="dm-media">{icon}</div>}
        {!icon && img && (
          <div className="dm-media">
            <img src={img} alt="modal-icon" />
          </div>
        )}

        {/* Title */}
        {title && <h2 className="dm-title">{title}</h2>}

        {/* Message */}
        {message && <p className="dm-text">{message}</p>}

        {/* Optional checkbox */}
        {checkboxLabel && (
          <label className="dm-check">
            <input
              type="checkbox"
              onChange={(e) => onCheckboxChange?.(e.target.checked)}
            />
            {checkboxLabel}
          </label>
        )}
      </Modal.Body>

      {/* Buttons */}
      <Modal.Footer className={`dm-footer${buttonText2 ? "" : " dm-footer-single"}`}>
        {/* Cancel / secondary button */}
        {buttonText2 && (
          <button
            type="button"
            className="dm-btn dm-btn-cancel"
            onClick={onSecondButtonClick || onClose}
          >
            {buttonText2}
          </button>
        )}

        {/* Primary / confirm button */}
        <button
          type="button"
          className={`dm-btn ${isDanger ? "dm-btn-danger" : "dm-btn-primary"}`}
          onClick={onPrimaryButtonClick || onClose}
        >
          {buttonText}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalSuccesUpdate;